import { getMenu } from '@app/constants/Qmenu.ts';
import { useToken } from '@app/hooks';
import { MobileSearch } from '@app/mobile/components';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import MobileMenuLi from './components/MobileMenuLi';
import * as S from './style';

import DarkMode from '../../../Footer/assets/DarkMode.svg?react';

import { ThemeContext } from '@/theme/ThemeProvider';
import { useNavigate } from 'react-router-dom';
import Dark_DarkMode from '../../../Footer/assets/Dark-DarkMode.svg?react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import BtnLanguageChange from '@app/organisms/Header/BtnLanguageChange';

export default function MobileMenu() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isDefault, setIsDefault] = useState(true);
  const { i18n } = useTranslation();
  
  // 언어 변경을 감지하기 위한 state
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  // 언어 변경 시 메뉴 업데이트를 위한 state
  const [menuItems, setMenuItems] = useState(getMenu());

  const { token } = useToken();

  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';

  const [search, setSearch] = useState(false);

  const navigate = useNavigate();

  // 언어 변경 감지
  useEffect(() => {
    if (currentLanguage !== i18n.language) {
      setCurrentLanguage(i18n.language);
      // 언어가 변경되면 메뉴 아이템 업데이트
      setMenuItems(getMenu());
      console.log('모바일 메뉴: 언어가 변경되어 메뉴를 업데이트합니다:', i18n.language);
    }
  }, [i18n.language, currentLanguage]);

  const themeToggler = () => {
    toggleTheme();
  };

  const handleToggleMenu = (menu: string) => {
    if (activeMenu === menu) {
      setActiveMenu(null);
    } else {
      setActiveMenu(menu);
    }
  };

  useEffect(() => {
    if (activeMenu) {
      setIsDefault(false);
    } else {
      setIsDefault(true);
    }
  }, [activeMenu]);

  return (
    <S.Container className="custom-scrollbar">
      {!token ? (
        <S.MenuBtnContainer>
          <S.MobileLoginBtn to="/login">{t("login")}</S.MobileLoginBtn>
          <S.MobileSignUpBtn to="/signup">{t("signUp")}</S.MobileSignUpBtn>
        </S.MenuBtnContainer>
      ) : (
        <S.MenuBtnContainer>
          <S.MobileSignUpBtn to="/trade/2">{t("trade")}</S.MobileSignUpBtn>
        </S.MenuBtnContainer>
      )}

      <S.SearchBox>
        {!search ? (
          <S.SearchInput onClick={() => setSearch(true)}>
            <span>Q</span>
            <input type="text" placeholder={t('search')} />
          </S.SearchInput>
        ) : (
          <MobileSearch setOpenSearch={setSearch} />
        )}
      </S.SearchBox>
      <S.MobileMenuList>
        {menuItems.map((menu) => (
          <MobileMenuLi
            key={menu.title}
            isDefault={isDefault}
            activeMenu={activeMenu}
            handleToggleMenu={handleToggleMenu}
            menu={menu}
          />
        ))}

        <MobileMenuLi
          isDefault={isDefault}
          activeMenu={activeMenu}
          handleToggleMenu={handleToggleMenu}
          menu={{
            title: t('assets'),
            link: '/asset',
            dropdown: false,
            subMenu: [],
          }}
        />
        {token && (
          <MobileMenuLi
            isDefault={isDefault}
            activeMenu={activeMenu}
            handleToggleMenu={handleToggleMenu}
            menu={{
              title: t('accountAndSecurity'),
              link: '/settings?tab=1',
              dropdown: false,
              subMenu: [],
            }}
          />
        )}
        <MobileMenuLi
            isDefault={isDefault}
            activeMenu={activeMenu}
            handleToggleMenu={handleToggleMenu}
            menu={{
              title: t('audit'),
              link: '/settings?tab=2',
              dropdown: false,
              subMenu: [],
            }}
          />
      </S.MobileMenuList>

      <UtilWrapper style={{ marginBottom: 10 }}>
        <UtilRow>
          <UtilText>{t('language')}</UtilText>
          <BtnLanguageChange />
        </UtilRow>
      </UtilWrapper>

      <UtilWrapper>

        {/*<UtilRow>*/}
        {/*	<UtilIcon as={theme === "light" ? Dark_Currency : Currency}/>*/}
        {/*	<UtilText>USD-$</UtilText>*/}
        {/*</UtilRow>*/}
        <UtilRow onClick={() => themeToggler()}>
          <UtilText>{t('theme')}</UtilText>
          <UtilIcon as={theme === 'light' ? Dark_DarkMode : DarkMode} />
        </UtilRow>
      </UtilWrapper>

      {token && (
        <UtilWrapper style={{ justifyContent: 'flex-end', marginTop: 100 }}>
          <UtilRow onClick={() => navigate('/logout')}>
            <UtilText>{t('logout')}</UtilText>
          </UtilRow>
        </UtilWrapper>
      )}
    </S.Container>
  );
}

const UtilWrapper = styled.div`
  display: flex;
  gap: 20px;
  padding: 0 20px;
`;

const UtilRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  cursor: pointer;
`;

const UtilText = styled.div`
  font-size: 15px;
  font-weight: 500;
  line-height: 16.71px;
  font-family: 'Pretendard', sans-serif;
  color: ${({ theme }) => theme.text};
`;

const UtilIcon = styled.svg`
  width: 24px;
  height: 24px;
  margin-bottom: 5px;
`;
